// Must match --breakpoint-xl in global.css — this app overrides Tailwind's default 1280px to 1200px.
const desktopMediaQuery = "(min-width: 1200px)";

export default desktopMediaQuery;
